import * as libInvestor from './investor';
// habitats/{uuid}/investors/{uuid}/investorSupportedIssuedInstruments/{uuid}
export const prefix = '/investorSupportedIssuedInstruments/';
export const IDToName = ({ habitatID, investorID, issuedInstrumentID }) => {
    return libInvestor.IDToName({ habitatID, investorID }) + prefix + issuedInstrumentID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 6) {
        throw new Error(`bad investor supported issued instrument name: ${name}`);
    }
    return { habitatID: parts[1], investorID: parts[3], issuedInstrumentID: parts[5] };
};
